import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http.postData("/persetujuan-kb", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id, data) {
  const response = await http.putData(`/persetujuan-kb/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/persetujuan-kb`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/persetujuan-kb/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function metodeList() {
  const response = await http.getData(`/persetujuan-kb/metode-list`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signOperator(id: number, data) {
  const response = await http.putData(`/persetujuan-kb/${id}/sign-operator`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signDpjp(id: number, data) {
  const response = await http.putData(`/persetujuan-kb/${id}/sign-dpjp`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signSaksiRs(id: number, data) {
  const response = await http.putData(`/persetujuan-kb/${id}/sign-saksi-rs`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function markAkseptor(id: number, data) {
  const response = await http.putData(`/persetujuan-kb/${id}/mark-akseptor`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function markPasangan(id: number, data) {
  const response = await http.putData(`/persetujuan-kb/${id}/mark-pasangan`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function markSaksiKeluarga(id: number, data) {
  const response = await http.putData(`/persetujuan-kb/${id}/mark-saksi-keluarga`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function recordPostProcedure(id: number, data) {
  const response = await http.putData(`/persetujuan-kb/${id}/post-procedure`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/persetujuan-kb/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

function print(id) {
  window.open(`${http.getAPI()}/persetujuan-kb/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  metodeList,
  signOperator,
  signDpjp,
  signSaksiRs,
  markAkseptor,
  markPasangan,
  markSaksiKeluarga,
  recordPostProcedure,
  destroy,
  print
};
